'use strict';

const initial = {
	screen: {
		width: 800,
		height: 600,
		size: 'lg'
	},
	mouse: {
		x: 400,
		y: 300
	}
};

module.exports = {
	initial
};
